import React from 'react';

interface Participant {
    id: string;
    name: string;
}

interface ExpenseFormProps {
    description: string;
    amount: string;
    paidBy: string;
    splitAmong: string[];
    participants: Participant[];
    isLoading: boolean;
    onDescriptionChange: (value: string) => void;
    onAmountChange: (value: string) => void;
    onPaidByChange: (value: string) => void;
    onToggleSplitParticipant: (id: string) => void;
    onAddExpense: () => void;
    onReceiptClick: () => void;
}

export const ExpenseForm: React.FC<ExpenseFormProps> = ({
    description,
    amount,
    paidBy,
    splitAmong,
    participants,
    isLoading,
    onDescriptionChange,
    onAmountChange,
    onPaidByChange,
    onToggleSplitParticipant,
    onAddExpense,
    onReceiptClick
}) => {
    const handleAmountChange = (value: string) => {
        const numbers = value.replace(/[^0-9]/g, '');
        if (numbers) {
            const formatted = parseInt(numbers).toLocaleString('ko-KR');
            onAmountChange(formatted);
        } else {
            onAmountChange('');
        }
    };

    const isValid = description.trim() && amount && splitAmong.length > 0;

    return (
        <>
            <div className="add-expense-form">
                <h3 className="form-title">새 지출 추가</h3>
                <button className="receipt-button-inline" onClick={onReceiptClick}>
                    📷 영수증으로 추가
                </button>

                <div className="form-group">
                    <label className="form-label">항목</label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="예: 식사비, 카페, 택시비"
                        value={description}
                        onChange={(e) => onDescriptionChange(e.target.value)}
                        maxLength={20}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">금액</label>
                    <div className="amount-row">
                        <select
                            className="payer-select"
                            value={paidBy}
                            onChange={(e) => onPaidByChange(e.target.value)}
                        >
                            {participants.map((participant) => (
                                <option key={participant.id} value={participant.id}>
                                    {participant.name}
                                </option>
                            ))}
                        </select>
                        <div className="input-with-unit">
                            <input
                                type="text"
                                className="form-input"
                                placeholder="0"
                                value={amount}
                                onChange={(e) => handleAmountChange(e.target.value)}
                                inputMode="numeric"
                            />
                            <span className="input-unit">원</span>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label className="form-label">지불대상자</label>
                    <div className="participant-chips">
                        {participants.map((participant) => (
                            <button
                                key={participant.id}
                                className={`participant-chip ${splitAmong.includes(participant.id) ? 'selected' : ''}`}
                                onClick={() => onToggleSplitParticipant(participant.id)}
                            >
                                {participant.name}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            <button
                className="add-button"
                onClick={onAddExpense}
                disabled={!isValid || isLoading}
            >
                {isLoading ? '추가 중...' : '+ 지출 추가'}
            </button>
        </>
    );
};
